import { Routes, Route } from 'react-router-dom'
import React from 'react'
import { ContentWrapper } from "./styled"
import { publicRouteData } from 'routes/public'
import { authRouteData } from 'routes/auth'
import { privateRouteData } from 'routes/private'
import AuthRoute from 'components/AuthRoute'
import PrivateRoute from 'components/PrivateRoute'
import Admin from 'views/Admin'
import PrivateRouteAdmin from 'components/PrivateRouteAdmin'
import { useSelector } from "react-redux"
import { authSelector } from 'redux/selector'
import { useLocation } from "react-router-dom"

function Content() {
    const authState = useSelector(authSelector)
    const path = useLocation().pathname
    return (
        <ContentWrapper isAdmin={path.includes("admin")}>
            <Routes>
                {publicRouteData.map((e, key) => (
                    <Route key={key} path={e.url} element={e.element} />
                ))}
                <Route element={<AuthRoute authenticate={authState.isLoggedIn} />}>
                    {authRouteData.map((e, key) => (
                        <Route key={key} path={e.url} element={e.element} />
                    ))}
                </Route>
                <Route element={<PrivateRoute authenticate={authState.isLoggedIn} />}>
                    {privateRouteData.map((e, key) => (
                        <Route key={key} path={e.url} element={e.element} />
                    ))}
                </Route>
                <Route element={<PrivateRouteAdmin authenticate={authState.isLoggedIn} isRole={authState.role} />}>
                    <Route path='/admin/:slug' element={<Admin />} />
                </Route>
            </Routes>
        </ContentWrapper >
    )
}
export default Content